import { getListCountry } from './../utils/getListCountry';
import { getListCurrency } from './../utils/getListCurrency';
import Storage from './Storage';

class Preload {
    static execute = (access_token) => {
        return new Promise((resolve, reject) => {
            Promise.all([
                getListCountry(access_token),
                getListCurrency(access_token)
            ]).then(res => {
                Storage.set('countries', res[0].data.data)
                Storage.set('currencies', res[1].data.data)

                resolve("done");
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default Preload


// WEBPACK FOOTER //
// ./src/services/Preload.js